// extracted by mini-css-extract-plugin
export default {"modalImage":"ContentArticles-modalImage","articleModal":"ContentArticles-articleModal","partnerFooter":"ContentArticles-partnerFooter","partnerCopy":"ContentArticles-partnerCopy"};